var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "widthFull center pt-0 pb-3 mb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "csHeight2" }, [
        _c(
          "div",
          { staticClass: "row justify-content-center text-left pt-2 " },
          [
            _c(
              "div",
              {
                staticClass:
                  "col-md-6 center mb-3 text-center pointer selectBlock",
                class: { blockActive: _vm.flow == "cdp" },
                on: {
                  click: function($event) {
                    _vm.flow = "cdp"
                  }
                }
              },
              [
                _c(
                  "h1",
                  { staticClass: "mt-4", class: { grey: _vm.flow == "poste" } },
                  [_c("b", [_vm._v(" CDP ")])]
                ),
                _vm._v(" "),
                _c("h4", { class: { grey: _vm.flow == "poste" } }, [
                  _vm._v("Cassa Depositi e Prestiti")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "col-md-6 center mb-3 text-center pointer selectBlock",
                class: { blockActive: _vm.flow == "poste" },
                on: {
                  click: function($event) {
                    _vm.flow = "poste"
                  }
                }
              },
              [
                _c(
                  "h1",
                  { staticClass: "mt-4", class: { grey: _vm.flow == "cdp" } },
                  [_c("b", [_vm._v(" Poste Italiane ")])]
                ),
                _vm._v(" "),
                _c("h4", { class: { grey: _vm.flow == "cdp" } }, [
                  _vm._v(" BancoPosta Affari")
                ])
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._l(_vm.disposals, function(item, index, k) {
              return [
                _c(
                  "div",
                  {
                    staticClass: "widthFull row pt-2 mb-5",
                    class: {
                      "pt-0": k == 0,
                      even33: String(index / 2).includes(".")
                    }
                  },
                  [
                    _c("div", { staticClass: "col-md-1 " }, [
                      _c("b", [_vm._v(_vm._s(item.id))])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 " }, [
                      _c("b", [
                        _vm._v(
                          _vm._s(
                            _vm.moment(item.created_at).format("DD-MM-YYYY")
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-5 " },
                      [
                        item.state == 0
                          ? [
                              _vm._v(
                                "\n              Creazione contratto di cessione a "
                              ),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 1
                          ? [
                              _vm._v(
                                "\n              Spostamento del credito dal cassetto fiscale dell'installatore a "
                              ),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 2
                          ? [
                              _vm._v("\n              Verifica "),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")],
                              _vm._v(" in corso\n            ")
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 3
                          ? [
                              _vm._v(
                                "\n              Cessione completata. Attendi il bonifico bancario di "
                              ),
                              _vm.flow == "cdp"
                                ? [_vm._v(" CDP ")]
                                : [_vm._v(" Poste Italiane ")],
                              _vm._v(" sul tuo conto corrente\n              "),
                              _vm.flow == "cdp"
                                ? [
                                    _vm._v(
                                      " indicato nel set Documenti per Eleggibilità CDP "
                                    )
                                  ]
                                : [_vm._v(" IBAN BancoPosta Affari ")]
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        item.state == 5
                          ? [_vm._v("\n              Errore\n            ")]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-1 " },
                      [
                        item.contract
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "check", size: "1x" }
                            })
                          : item.state == 0
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "", size: "1x" }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-1 " },
                      [
                        item.screenshot
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "check", size: "1x" }
                            })
                          : item.state == 1
                          ? _c("font-awesome-icon", {
                              attrs: { icon: "spinner", spin: "", size: "1x" }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-2 text-right" }, [
                      _c("b", [
                        _vm._v(
                          "€ " +
                            _vm._s(
                              _vm._f("formatNumber")(item.totalDisposalAmount)
                            )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    item.state == 1 &&
                    (_vm.getProfile.delegate_move_credits == 2 ||
                      _vm.getProfile.delegate_move_credits == "2")
                      ? _c(
                          "div",
                          { staticClass: "col-md-12 borderTop mt-2 pt-3 pb-3" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-5 pl-md-5" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull  black" },
                                  [
                                    _vm._v(
                                      "\n                  Per procedere con la Cessione a "
                                    ),
                                    _vm.flow == "cdp"
                                      ? [_vm._v(" CDP ")]
                                      : [_vm._v(" Poste Italiane ")],
                                    _vm._v(":\n                ")
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  [
                                    _c("b", [_vm._v("1)")]),
                                    _vm._v(
                                      "  Effettua lo spostamento del credito dal tuo cassetto fiscale a quello "
                                    ),
                                    _vm.flow == "cdp"
                                      ? [_vm._v(" CDP ")]
                                      : [_vm._v(" Poste Italiane ")],
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "ml-4" },
                                      [
                                        _vm._v(" - codice fiscale di "),
                                        _vm.flow == "cdp"
                                          ? [_vm._v(" CDP")]
                                          : [_vm._v(" Poste Italiane")],
                                        _vm._v(": "),
                                        _c("b", [
                                          _vm._v(
                                            " " +
                                              _vm._s(item.cessionaryCode) +
                                              " "
                                          )
                                        ])
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-4" }, [
                                      _vm._v(
                                        " Totale importo di Cessione per codice tributo:\n                      "
                                      ),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-4" }, [
                                        _vm._v(" - Ecobonus Ordinario "),
                                        _c("b", [
                                          _vm._v(
                                            " ( Codice Tributo 6922 ): €  " +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  item.countEcobonus
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-4" }, [
                                        _vm._v(" - Ristrutturazione "),
                                        _c("b", [
                                          _vm._v(
                                            " ( Codice Tributo 6926 ): €  " +
                                              _vm._s(
                                                _vm._f("formatNumber")(
                                                  item.countBonusCasa
                                                )
                                              ) +
                                              " "
                                          )
                                        ])
                                      ])
                                    ])
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _vm._m(2, true),
                                _vm._v(" "),
                                _vm._m(3, true)
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\n                  Carica la fotografia (screenshot)\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "center" },
                                  [
                                    _vm._v(
                                      "che conferma la movimentazione del credito a "
                                    ),
                                    _vm.flow == "cdp"
                                      ? [_vm._v(" CDP ")]
                                      : [_vm._v(" Poste Italiane ")]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "front-image" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          size: 10240,
                                          ext: ["jpeg", "jpg", "png", "pdf"],
                                          mimes: [
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                            "application/pdf"
                                          ]
                                        },
                                        expression:
                                          "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                      }
                                    ],
                                    ref: "fileInput",
                                    refInFor: true,
                                    staticClass: "fileInput",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "invoiceFront"
                                      ),
                                      valid: !!_vm.invoiceFront,
                                      helper: !!_vm.invoiceFrontBucket
                                    },
                                    attrs: {
                                      type: "file",
                                      multiple: "",
                                      name: "invoiceFront",
                                      id: "invoiceFront",
                                      "data-vv-as": "screenshot"
                                    },
                                    on: { change: _vm.uploadFile }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoiceFront" }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "smallText center white",
                                              style: {
                                                backgroundImage:
                                                  "url(" +
                                                  _vm.invoiceFrontBucket +
                                                  ")"
                                              }
                                            },
                                            [
                                              !_vm.invoiceFrontName
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "smallText center white mt-3 mb-0 pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli il Contratto quadro*"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "smallText center white",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                _vm.invoiceFrontBucket +
                                                ")"
                                            }
                                          })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoiceFront")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { top: "185px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.errors.first("invoiceFront")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress mt-5",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar ",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                        },
                                        [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 mt-5 mb-3 center" },
                                [
                                  _vm.invoiceFrontBucket
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.invoiceFrontBucket,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm.invoiceFrontBucket.substring(
                                            _vm.invoiceFrontBucket.lastIndexOf(
                                              "."
                                            ) + 1,
                                            _vm.invoiceFrontBucket.length
                                          ) == "pdf"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "center widthFull pdfLink",
                                                  attrs: {
                                                    href:
                                                      _vm.invoiceFrontBucket,
                                                    target: "_blank"
                                                  }
                                                },
                                                [_vm._v("APRI PDF")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 center pt-1" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btnRed",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmLoadScreenshot(
                                            item.id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Procedi")]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    item.state == 0 && _vm.flow == "poste"
                      ? _c(
                          "div",
                          { staticClass: "col-md-12 borderTop mt-2 pt-3 pb-3" },
                          [
                            item.final_responce_message
                              ? _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-12 pl-md-5" },
                                    [
                                      _c("h5", {
                                        staticClass: "red center",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            item.final_responce_message
                                          )
                                        }
                                      })
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-md-5 pl-md-5" }, [
                                _c("h4", { staticClass: "widthFull  black" }, [
                                  _vm._v(
                                    "\n                  Per procedere con la Cessione a Poste Italiane:\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _c("b", [_vm._v("1)")]),
                                  _vm._v(
                                    "  Accedi all'area riservata del tuo conto BancoPosta Business e sottoscrivi il contratto di Cessione del credito in funzione del codice tributo:\n                    "
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "ml-4" }, [
                                    _vm._v(
                                      " Totale importo di Cessione per codice tributo:\n                      "
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-4" }, [
                                      _vm._v(" - Ecobonus Ordinario "),
                                      _c("b", [
                                        _vm._v(
                                          " ( Codice Tributo 6922 ): €  " +
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                item.countEcobonus
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "ml-4" }, [
                                      _vm._v(" - Ristrutturazione "),
                                      _c("b", [
                                        _vm._v(
                                          " ( Codice Tributo 6926 ): €  " +
                                            _vm._s(
                                              _vm._f("formatNumber")(
                                                item.countBonusCasa
                                              )
                                            ) +
                                            " "
                                        )
                                      ])
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _vm._m(4, true)
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-md-6" }, [
                                _c(
                                  "h4",
                                  { staticClass: "widthFull center black" },
                                  [
                                    _vm._v(
                                      "\n                  Carica il contratto\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("p", { staticClass: "center" }, [
                                  _vm._v(
                                    "di Cessione del credito ricevuto da Poste Italiane"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "front-image" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: true,
                                          size: 10240,
                                          ext: ["jpeg", "jpg", "png", "pdf"],
                                          mimes: [
                                            "image/jpeg",
                                            "image/jpg",
                                            "image/png",
                                            "application/pdf"
                                          ]
                                        },
                                        expression:
                                          "{required:true,size: 10240, ext: ['jpeg','jpg','png','pdf'], mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']}"
                                      }
                                    ],
                                    ref: "fileInput",
                                    refInFor: true,
                                    staticClass: "fileInput",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "invoiceFront"
                                      ),
                                      valid: !!_vm.invoiceFront,
                                      helper: !!_vm.invoiceFrontBucket
                                    },
                                    attrs: {
                                      type: "file",
                                      multiple: "",
                                      name: "invoiceFront",
                                      id: "invoiceFront",
                                      "data-vv-as": "contratto di Cessione"
                                    },
                                    on: { change: _vm.uploadFile }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "niceInputLabel labelFileInput",
                                      attrs: { for: "invoiceFront" }
                                    },
                                    [
                                      !_vm.invoiceFrontName
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "smallText center white",
                                              style: {
                                                backgroundImage:
                                                  "url(" +
                                                  _vm.invoiceFrontBucket +
                                                  ")"
                                              }
                                            },
                                            [
                                              !_vm.invoiceFrontName
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "smallText center white mt-3 mb-0 pb-0"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Scegli il Contratto quadro*"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        : _c("span", {
                                            staticClass:
                                              "smallText center white",
                                            style: {
                                              backgroundImage:
                                                "url(" +
                                                _vm.invoiceFrontBucket +
                                                ")"
                                            }
                                          })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("invoiceFront")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "invalid-feedback",
                                          staticStyle: { top: "185px" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.errors.first("invoiceFront")
                                              ) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.uploadFrontPercentage
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "progress mt-5",
                                          attrs: { id: "progFront" }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "progress-bar ",
                                              style: {
                                                width:
                                                  _vm.uploadFrontPercentage +
                                                  "%"
                                              },
                                              attrs: {
                                                id: "progress-bar-front",
                                                role: "progressbar",
                                                "aria-valuenow": "50",
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.uploadFrontPercentage
                                                  ) +
                                                  " %\n                    "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invoiceFrontName
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                        },
                                        [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 mt-5 mb-3 center" },
                                [
                                  _vm.invoiceFrontBucket
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href: _vm.invoiceFrontBucket,
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm.invoiceFrontBucket.substring(
                                            _vm.invoiceFrontBucket.lastIndexOf(
                                              "."
                                            ) + 1,
                                            _vm.invoiceFrontBucket.length
                                          ) == "pdf"
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "center widthFull pdfLink",
                                                  attrs: {
                                                    href:
                                                      _vm.invoiceFrontBucket,
                                                    target: "_blank"
                                                  }
                                                },
                                                [_vm._v("APRI PDF")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 center pt-1" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary btnRed",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmLoadContract(
                                            item.id,
                                            item
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Procedi")]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-12 borderTop2 mt-2" }, [
                      _vm._v("\n            Derivante dalle Pratiche: "),
                      _c("b", [
                        _vm._v(_vm._s(item.practices.replaceAll(",", ", ")))
                      ])
                    ])
                  ]
                )
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "widthFull row  mb-2" }, [
          _c("div", { staticClass: "col-md-8 " }),
          _vm._v(" "),
          _vm.totalDisposal != 0
            ? _c("div", { staticClass: "col-md-4 text-right" }, [
                _vm._v("\n        Importo totale Cessioni in corso "),
                _c("b", [
                  _vm._v(
                    "€ " +
                      _vm._s(_vm._f("formatNumber")(_vm.totalDisposal)) +
                      " "
                  )
                ])
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "widthFull  mt-5 " },
        [
          _vm._v(
            "* Trasferimento dei crediti dal cassetto fiscale dell'installatore a quello di "
          ),
          _vm.flow == "cdp" ? [_vm._v(" CDP ")] : [_vm._v(" Poste Italiane ")]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 center mb-4" }, [
      _c("h4", [_c("b", [_vm._v("Elenco Cessioni in corso")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widthFull row even mb-2" }, [
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("N.Cessione")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 " }, [
        _c("small", [_vm._v("Data di creazione")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-5 " }, [_c("small", [_vm._v("Stato")])]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("Contratto")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-1 " }, [
        _c("small", [_vm._v("Movimentazione*")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-2 text-right" }, [
        _c("small", [_vm._v("Importo di Cessione")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("b", [_vm._v("2)")]),
      _vm._v(
        "  Fai una fotografia (screenshot) della movimentazione del credito sul tuo cassetto fiscale\n\n                  "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("b", [_vm._v("3)")]),
      _vm._v("  Carica la fotografia (screenshot) e clicca sul pulsante "),
      _c("b", [_vm._v('"PROCEDI"')])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("b", [_vm._v("2)")]),
      _vm._v(
        "  Carica contratto di Cessione ricevuto da Poste Italiane e clicca sul pulsante "
      ),
      _c("b", [_vm._v('"PROCEDI"')])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54242612", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54242612","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cessioni/practicesinWork.vue
// module id = null
// module chunks = 